const ChartEvent = {
  PERIOD_CHANGED: 'chartPeriodChanged',
  DATE_SELECTED_ON_SCHEMA_TABLE: 'chartDateSelectedOnSchemaTable',
};

export default ChartEvent;
